import React from 'react';

import { BusinessPageLayout } from '@/layouts';
import {
  AboutSection as AboutMobileSection,
  ProcessSection,
  SpecialtySection,
  WorksSection,
} from '@/views/business/viral/sections';

const ViralPage = () => {
  return (
    <BusinessPageLayout curPageIdx={0} nextPageHref="/business/media">
      <AboutMobileSection />
      <SpecialtySection />
      <ProcessSection />
      <WorksSection />
    </BusinessPageLayout>
  );
};

export default ViralPage;
